import React from 'react';
import { FieldWrapper } from './fieldWrapper';
import { AntInput } from '../../../ant/antInput';
import { Property } from '../models';
import { observer } from 'mobx-react';
import { FormBuilderContext } from '../formBuilderContext';

export const CELabel = observer(({ property }: { property: Property }) => {
	const store = React.useContext(FormBuilderContext);
	return (
		<FieldWrapper property={property}>
			<AntInput onBlur={() => store.onPropertyBlur(property)} readOnly={true} />
		</FieldWrapper>
	);
});
